import React from 'react'
import { Icon, IconButton, Modal } from 'rsuite'

export default function PopupModal({
  title = 'แจ้งเตือน',
  body,
  isShow,
  onClickSubmit = () => {},
  onClickCancel = () => {},
  submitText = 'ตกลง',
  cancelText = 'ยกเลิก',
  submitIcon = 'check',
  cancelIcon = 'close',
}) {
  return (
    <div>
      <Modal show={isShow} onHide={onClickCancel}>
        <Modal.Header>
          <Modal.Title>
            <p style={{ paddingTop: '0.5rem' }}>{title}</p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{body}</Modal.Body>
        <Modal.Footer>
          <IconButton
            appearance="ghost"
            icon={<Icon icon={submitIcon} className={'bt-gost-icon-radius'} />}
            onClick={onClickSubmit}
          >
            {submitText}
          </IconButton>
          <IconButton
            appearance="ghost"
            className={'rs-btn-ghost-cancel'}
            icon={<Icon icon={cancelIcon} className={'bt-gost-icon-radius-cancel'} />}
            onClick={onClickCancel}
          >
            {cancelText}
          </IconButton>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
